export default __webpack_public_path__ + "3b0b8e5e5cf3a29c7db15f3c28dea773.png";